import React from "react"

const AuthContext = React.createContext({
  loggedInState: null,
  checkLoggedInState: () => {},
  performRegister: () => {},
  performLogin: () => {},
  performLogout: () => {},
})

export default AuthContext
